import { createContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import useSession from '../hooks/useSession';

const AuthContext = createContext({
  sessionStore: {},
  sessionHelpers: {},
});

const AuthProvider = ({ children }) => {
  const { sessionStore, sessionHelpers } = useSession();
  const contextValue = useMemo(
    () => ({ sessionStore, sessionHelpers }),
    [sessionHelpers, sessionStore]
  );
  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};
AuthProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export { AuthContext, AuthProvider };
